import Alpine from "alpinejs";
import productform from "./scripts/product-form";
//import menu from "./scripts/menu";
import menuDesktop from "./scripts/menuDesktop";
import menuMobile from "./scripts/menuMobile";
import search from "./scripts/search";
// import quickSearch from "./scripts/quickSearch";
import quickShop from "./scripts/quick-shop";
import intersect from "@alpinejs/intersect";
import cta from "./scripts/cta";
import marquee from "./scripts/marquee";
import hero from "./scripts/hero";
import variantPicker from "./scripts/variantPicker";
import cart from "./scripts/cart";
import cartNotice from "./scripts/cartNotice";
import facetsDrawer from "./scripts/facetsDrawer";
import facets from "./scripts/facets";
import sizeGuide from "./scripts/sizeGuide";
import productSlider from "./scripts/productSlider";
import productSliderNosto from "./scripts/productSliderNosto";
import productDetails from "./scripts/productDetails";
import cartCount from "./scripts/cartCount";
import countrySelector from "./scripts/countrySelector";
import countryPopup from "./scripts/countryPopup";
import shopTheLook from "./scripts/shop-the-look";
import outfitGuide from "./scripts/outfitGuide";
import outfitGrid from "./scripts/outfitGrid";
import imageZoom from "./scripts/image-zoom";
import categories from "./scripts/categories";
import background from "./scripts/background";
import notifyMe from "./scripts/notify-me";
import shopTheLookModule from "./scripts/shopTheLookModule";
import video from "./scripts/video";
import wishlist from "./scripts/wishlist";
import buttonWishlist from "./scripts/button-wishlist";
import countdown from "./scripts/countdown";
import countdownClock from "./scripts/countdown-clock";
import store from "./scripts/store";
import pdpImageSlider from "./scripts/pdp-image-slider";
import outfitAddToCart from "./scripts/outfitAddToCart";
import outfitAddToCartItem from "./scripts/outfitAddToCartItem";
import lookbook from "./scripts/lookbook";
import myAccount from "./scripts/myAccount";
import login from "./scripts/login";
import myProfile from "./scripts/myProfile";
import addressOverlay from "./scripts/addressOverlay";
import loginOverlay from "./scripts/loginOverlay";
import registerOverlay from "./scripts/registerOverlay";
import passwordOverlay from "./scripts/passwordOverlay";
import myStoreOrders from "./scripts/myStoreOrders";
import registerSection from "./scripts/registerSection";
import genderRangeSlider from "./scripts/genderRangeSlider";
import interestsPreference from "./scripts/interestsPreference";
import interestsWrapper from "./scripts/interestsWrapper";
import sizePreference from "./scripts/sizePreference";
import collection from "./scripts/collection";
import newsletterConsent from "./scripts/newsletterConsent";
import scheduleRow from "./scripts/scheduleRow";
import lookbookPLP from "./scripts/lookbookPLP";
import dynamicVideoSource from "./scripts/dynamicVideoSource";
import inventoryDrawer from "./scripts/inventoryDrawer";
import backInStockModal from "./scripts/back-in-stock-modal";
import gridSwitch from "./scripts/gridSwitch";
import countdownTimer from "./scripts/countdownTimer";
import sliderHero from "./scripts/slider-hero";
import sliderHeroSlide from "./scripts/slider-hero-slide";
import media from "./scripts/media";
import headerContent from "./scripts/header-content";
import header from "./scripts/header";
import centeredSlider from "./scripts/centeredSlider";
import categoryHover from "./scripts/categoryHover";
import uspBar from "./scripts/usp-bar";
import pdpButtons from "./scripts/pdp-buttons";
import pdpGallerySlider from "../shopify/assets/pdp-gallery-slider.js";

Alpine.plugin(intersect);

Alpine.data("productform", productform);
Alpine.data("cart", cart);
Alpine.data("cartCount", cartCount);
Alpine.data("cartNotice", cartNotice);
Alpine.data("facetsDrawer", facetsDrawer);
Alpine.data("facets", facets);
Alpine.data("countrySelector", countrySelector);
Alpine.data("countryPopup", countryPopup);
Alpine.data("cta", cta);
Alpine.data("hero", hero);
Alpine.data("menuDesktop", menuDesktop);
Alpine.data("menuMobile", menuMobile);
Alpine.data("quickShop", quickShop);
Alpine.data("search", search);
// Alpine.data("quickSearch", quickSearch);
Alpine.data("Marquee", marquee);
Alpine.data("productSlider", productSlider);
Alpine.data("productSliderNosto", productSliderNosto);
Alpine.data("productDetails", productDetails);
Alpine.data("variantPicker", variantPicker);
Alpine.data("shopTheLook", shopTheLook);
Alpine.data("outfitGuide", outfitGuide);
Alpine.data("outfitGrid", outfitGrid);
Alpine.data("imageZoom", imageZoom);
Alpine.data("sizeGuide", sizeGuide);
Alpine.data("categories", categories);
Alpine.data("background", background);
Alpine.data("notifyMe", notifyMe);
Alpine.data("shopTheLookModule", shopTheLookModule);
Alpine.data("video", video);
Alpine.data("wishlist", wishlist);
Alpine.data("buttonWishlist", buttonWishlist);
Alpine.data("countdown", countdown);
Alpine.data("countdownClock", countdownClock);
Alpine.data("store", store);
Alpine.data("pdpImageSlider", pdpImageSlider);
Alpine.data("outfitAddToCart", outfitAddToCart);
Alpine.data("outfitAddToCartItem", outfitAddToCartItem);
Alpine.data("lookbook", lookbook);
Alpine.data("myAccount", myAccount);
Alpine.data("login", login);
Alpine.data("loginOverlay", loginOverlay);
Alpine.data("registerOverlay", registerOverlay);
Alpine.data("passwordOverlay", passwordOverlay);
Alpine.data("myStoreOrders", myStoreOrders);
Alpine.data("registerSection", registerSection);
Alpine.data("myProfile", myProfile);
Alpine.data("addressOverlay", addressOverlay);
Alpine.data("genderRangeSlider", genderRangeSlider);
Alpine.data("interestsPreference", interestsPreference);
Alpine.data("interestsWrapper", interestsWrapper);
Alpine.data("sizePreference", sizePreference);
Alpine.data("collection", collection);
Alpine.data("lookbookPLP", lookbookPLP);
Alpine.data("newsletterConsent", newsletterConsent);
Alpine.data("scheduleRow", scheduleRow);
Alpine.data("dynamicVideoSource", dynamicVideoSource);
Alpine.data("inventoryDrawer", inventoryDrawer);
Alpine.data("backInStockModal", backInStockModal);
Alpine.data("gridSwitch", gridSwitch);
Alpine.data("countdownTimer", countdownTimer);
Alpine.data("sliderHero", sliderHero);
Alpine.data("sliderHeroSlide", sliderHeroSlide);
Alpine.data("media", media);
Alpine.data("headerContent", headerContent);
Alpine.data("header", header);
Alpine.data("centeredSlider", centeredSlider);
Alpine.data("categoryHover", categoryHover);
Alpine.data("uspBar", uspBar);
Alpine.data("pdpButtons", pdpButtons);
Alpine.data("pdpGallerySlider", pdpGallerySlider);
window.Alpine = Alpine;

// Initialize stores before Alpine.start()
Alpine.store("quickShopSource", {
  source: null,
  set(from) {
    this.source = from;
  },
});

Alpine.store("nostoState", {
  data: {
    attributionKey: null,
    productId: null,
    refSrc: null,
    productUrl: null,
    originUrl: null,
  },
  set(data) {
    this.data = data;
  },
  clear() {
    this.data = {
      attributionKey: null,
      productId: null,
      refSrc: null,
      productUrl: null,
      originUrl: null,
    };
  },
});

Alpine.store("shopTheLookState", {
  open: false,
  set(state) {
    this.open = state;
  },
});

Alpine.store("countryPopup", {
  open: false,
  userLocation: "",
  link: "",
  countryCode: "",

  set(state, location, link, countryCode = "") {
    this.userLocation = location;
    this.link = link;
    this.countryCode = countryCode;
    this.open = state;
  },
});

Alpine.start();

let Grebify = {
  noScroll(active = true) {
    const body = document.querySelector("body");
    if (active) {
      body.classList.add("no-scroll");
    } else {
      body.classList.remove("no-scroll");
    }
  },
  scrollToElement(selector) {
    const element = document.querySelector(selector);
    element.scrollIntoView({ behavior: "smooth", block: "center" });
  },
};

window.Grebify = Grebify;

window.debounce = function (fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

// Open external links in new tab/window
(function () {
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = "_blank";
      links[i].rel = "noreferrer noopener";
    }
  }
})();

document.addEventListener("DOMContentLoaded", function () {
  //Open welcome overlay after login
  const queryString = window.location.search;
  if (queryString === "?login=true") {
    const event = new CustomEvent("login-toggle", {
      detail: { active: "welcome" },
    });
    window.dispatchEvent(event);
  }
  //Save guest favorites to customer favorites after login
  CF.customerReady(function () {
    const customerFavorites = CF.customer.get("favorites_list");
    if (
      CF.customer.unsavedChanges.favorites_list &&
      customerFavorites.length === 0
    ) {
      CF.customer.update({
        favorites_list: CF.customer.unsavedChanges.favorites_list,
      });
    }
  });

  function isVideoSource(element) {
    return typeof element.tagName === "string" && element.tagName === "SOURCE";
  }

  function setResponsiveVideoSrc(videoSource) {
    if (isVideoSource(videoSource)) {
      const isMobile = window.innerWidth < 1024;
      const mobile = videoSource.dataset.mobile;
      const src = videoSource.dataset.src;

      const isValidMobile = mobile && isMobile && src;
      const isValidDesktop = !mobile && !isMobile && src;

      if (isValidMobile || isValidDesktop) {
        videoSource.src = src;
        return true;
      }
    }

    return false;
  }

  /**
   * Load non lazy responsive videos
   */
  var responsiveVideos = [].slice.call(
    document.querySelectorAll("video.responsive")
  );

  if ("ResizeObserver" in window) {
    const responsiveVideoObserver = new ResizeObserver((entries) => {
      entries.forEach(function (video) {
        let srcLoaded = false;

        for (var source in video.target.children) {
          const videoSource = video.target.children[source];
          srcLoaded = srcLoaded || setResponsiveVideoSrc(videoSource);
        }

        if (srcLoaded) {
          video.target.load();
          responsiveVideoObserver.unobserve(video.target);
        }
      });
    });

    responsiveVideos.forEach(function (responsiveVideo) {
      responsiveVideoObserver.observe(responsiveVideo);
    });
  }

  /**
   * Load lazy videos
   */
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (isVideoSource(videoSource)) {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});
